<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-31 10:20:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/refund/chooserefundtype/components/OrderShopHead/index.vue
-->
<template>
  <div>
    <div class="store_det">
      <img src="@/assets/order/icon_order1@2x.png" alt="" class="store_logo" />
      <span>{{
        getPeriodOptionalAfterOrder.storeName || $G("全球购助手")
      }}</span>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="store_go"
      />
      <span v-if="orderType === 0 && refundProductList" class="p_sub right"
        >共{{
          refundProductList.reduce((sum, item) => sum + item.modifyNum, 0)
        }}件商品</span
      >
      <span v-if="orderType === 1 && refundProductList" class="p_sub right"
        >共{{
          refundProductList.reduce((sum, item) => sum + item.skuAmount, 0)
        }}件商品</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    showNum: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  computed: {
    getPeriodOptionalAfterOrder() {
      return this.$store.getters.getPeriodOptionalAfterOrder;
    },
  },
  watch: {
    getPeriodOptionalAfterOrder(oldV, newV) {
      console.log(oldV, newV);
      if (this.orderType === 1) {
        this.refundProductList.push(this.getPeriodOptionalAfterOrder.skuInfo);
      }
    },
  },
  data() {
    return {
      refundProductList: [],
      orderType: 0,
    };
  },
  created() {
    this.orderType = parseInt(localStorage.getItem("mall-wap-refund-type"));
    if (this.orderType === 0) {
      this.refundProductList = JSON.parse(
        localStorage.getItem("mall-wap-refund-list")
      );
    }
  },
};
</script>

<style scoped>
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: "";
  clear: both;
  height: 0;
}
.left {
  float: left;
}
.right {
  float: right;
}
.store_det {
  padding: 17px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #222;
  line-height: 26px;
}
.store_logo {
  width: 24px;
  vertical-align: middle;
  margin-right: 5px;
}
.store_go {
  width: 24px;
  vertical-align: middle;
}
.p_sub {
  font-size: 14px;
  font-weight: 500;
  color: #999;
  line-height: 24px;
}
</style>
